import { Language, defaultTheme } from '@marketertechnologies/property-picker';
import { propertyPickerStaticColors, useIframeModuleTheme } from '@marketertechnologies/ui-library';
import { camelizeKeys } from 'humps';
import { pick } from 'ramda';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import {
  PropertyExplorerProjectData,
  getPropertyExplorerProjectData,
} from '~/queries/getPropertyExplorerProjectData';

type UseProjectDataArgs = {
  initialLanguage: Language;
};

export const usePropertyExplorerProjectData = ({ initialLanguage }: UseProjectDataArgs) => {
  const { uuid } = useParams();

  const [data, setData] = useState<PropertyExplorerProjectData>();
  const [language, setLanguage] = useState(initialLanguage);
  const [projectUuid, setProjectUuid] = useState(uuid);

  useEffect(() => {
    const callback = (e: MessageEvent) => {
      try {
        const data = JSON.parse(e.data);

        if (data.type === 'change-language') {
          setLanguage(data.payload);
        }

        if (data.type === 'change-project') {
          setProjectUuid(data.payload);
        }
      } catch (_) {
        // do nothing
      }
    };

    window.addEventListener('message', callback);

    return () => window.removeEventListener('message', callback);
  }, []);

  useEffect(() => {
    if (!projectUuid) return;

    getPropertyExplorerProjectData(projectUuid)
      .then((response) => setData(camelizeKeys<PropertyExplorerProjectData>(response)))
      .catch((error) => {
        console.error(`Failed loading project data: ${error}`);
      });
  }, [projectUuid]);

  const theme = useIframeModuleTheme({
    ...defaultTheme,
    colors: {
      ...defaultTheme.colors,
      ...pick(propertyPickerStaticColors, data?.theme ?? {}),
    },
  });

  return data
    ? {
        ...data,
        theme,
        language,
      }
    : undefined;
};
